// extracted by mini-css-extract-plugin
module.exports = {"c-headline":"headline_c-headline__uVm1_","c-headline_text":"headline_c-headline_text__xsOfy"};